import { AgreementChangeReasonTypeEnum } from 'CorePackage/CatalogsModule/enums/AgreementChangeReasonTypesEnum';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

/**
 * Опции для выбора типа изменения соглашения
 */
export const agreementsChangeTypeSelectOptions: ISelectOption[] = [
  {
    id: AgreementChangeReasonTypeEnum.EXTENSION,
    label: 'Продление срока исполнения',
    value: 'EXTENSION_OF_DEADLINE',
  },
  {
    id: AgreementChangeReasonTypeEnum.CHANGE,
    label: 'Изменение соглашения',
    value: 'CHANGE_OF_AGREEMENT',
  },
];
